/**
 * This function is the wrapper for the Optanon functionality.
 */
function OptanonWrapper() { }

/**
 * This constant represents the category for performance cookies.
 */
const performanceCookieCategory = 'C0002,';

/**
 * This function waits for the OneTrust script to load and then executes the necessary actions.
 */
function waitForOneTrust() {
	hasOneTrustLoaded();
	let attempts = 0;
	const interval = setInterval(function () {
		if (hasOneTrustLoaded() || attempts > 100) {
			clearInterval(interval);
		}
		attempts++;
	}, 100);
}

/**
 * This function checks if the OneTrust script has loaded.
 * If it has loaded, it calls the optanonWrapper function and sets the OptanonWrapper property on the window object.
 * @returns {boolean} - True if the OneTrust script has loaded, false otherwise.
 */
function hasOneTrustLoaded() {
	if (typeof window.OnetrustActiveGroups === 'string') {
		optanonWrapper();
		window.OptanonWrapper = optanonWrapper;
		return true;
	}
	return false;
}

/**
 * This function sends the consent for tracking to Shopify.
 * @param {boolean} trackingConsent - The tracking consent value.
 */
function sendConsent(trackingConsent) {
	window.Shopify.customerPrivacy.setTrackingConsent(trackingConsent, () => {});
}

/**
 * This function handles the logic for the Optanon wrapper.
 * It checks if the performance cookie category is included in the active groups.
 * It also sets up event listeners for consent buttons and logs the consent approval.
 */
function optanonWrapper() {
	const trackingConsent = !!window.OnetrustActiveGroups.includes(
		performanceCookieCategory
	);
	var consentButton = document.getElementById(
		'onetrust-accept-btn-handler'
	);
	var consentButtonInModal = document.getElementById(
		'accept-recommended-btn-handler'
	);
	var consentButtonConfirmChoicesInModal = document.querySelector(
		'button.save-preference-btn-handler.onetrust-close-btn-handler'
	);

	window.Shopify.loadFeatures(
		[
			{
				name: 'consent-tracking-api',
				version: '0.1',
			},
		],
		(error) => {
			if (error) {
				throw error;
			}

			if (consentButton) {
				consentButton.addEventListener('click', () => {
					sendConsent(trackingConsent);
					console.log('Consent approved - primary banner', trackingConsent);
				});
			}

			if (consentButtonInModal) {
				consentButtonInModal.addEventListener('click', () => {
					sendConsent(trackingConsent);
					console.log('Consent approved - custom preferences in modal', trackingConsent);
				});
			}

			if (consentButtonConfirmChoicesInModal) {
				consentButtonConfirmChoicesInModal.addEventListener('click', () => {
					sendConsent(trackingConsent);
					console.log('Consent approved - confirm choices in modal', trackingConsent);
				});
			}
		}
	);
}

/**
 * Immediately invoked function expression (IIFE) that waits for OneTrust and executes the necessary actions.
 */
(function () {
	waitForOneTrust();
})();
